import * as types from 'actions/app';
import {
    LOGOUT_REQUEST,
    LOGIN_REQUEST,
    SIGNUP_REQUEST,
} from 'actions/auth';

const initialState = {
	initialized: false,
    email: null,
    submitting: false,
    submited: false,
    states: [],
    businessInfo: null,
    loanApplication: null,
    legalEntityTypes: [],
    businessQualifies: 0,
    documents: {
	    loading: false,
        position: -1,
    },
};

const app = (state = initialState, action) => {
    switch (action.type) {
        case types.UPLOAD_STATEMENT_REQUEST:
        case types.DELETE_STATEMENT_REQUEST:
            return {
                ...state,
                documents: {
                    position: action.position,
                    loading: true,
                }
            };
        case types.DELETE_STATEMENT_SUCCESS:
        case types.UPLOAD_STATEMENT_SUCCESS:
            return {
                ...state,
                documents: {
                    position: action.position,
                    loading: false,
                }
            };
        case types.STORE_BUSINESS_QUALIFICATION:
            return {
                ...state,
                businessQualifies: action.payload
            };
        case types.RESET_BUSINESS_QUALIFICATION:
            return {
                ...state,
                businessQualifies: 0
            };
		case types.INITIALIZED:
			return {
                ...state,
                initialized: true
            };
        case LOGOUT_REQUEST:
        case LOGIN_REQUEST:
        case SIGNUP_REQUEST:
            return {
                ...state,
				email: null,
				submitting: false,
				submited: false,
				states: [],
				businessInfo: null,
				loanApplication: null,
				legalEntityTypes: []
            };
        case types.FETCH_STATES_SUCCESS:
            return {
                ...state,
                states: action.payload
            };
        case types.FETCH_LEGAL_ENTITY_TYPES_SUCCESS:
            return {
                ...state,
                legalEntityTypes: action.payload
            };
        case types.SAVE_INITIAL_APPLICATION_REQUEST:
            return {
                ...state,
                submitting: true,
                submited: false
            };
        case types.SAVE_INITIAL_APPLICATION_SUCCESS:
            return {
				...state,
                submitting: false,
                submited: true,
                email: action.payload.email
            };
        case types.SAVE_INITIAL_APPLICATION_FAILURE:
            return {
				...state,
                submitting: false,
                submited: false
            };
        case types.FETCH_PENDING_LOAN_APPLICATION_REQUEST:
            return {
                ...state,
                submitting: true,
                submited: false
            };
        case types.FETCH_PENDING_LOAN_APPLICATION_SUCCESS:
		case types.SAVE_LOAN_INFO_SUCCESS:
		case types.SAVE_OWNERS_INFO_SUCCESS:
		case types.SAVE_BIZ_INFO_SUCCESS:
		case types.SAVE_APPLICATION_SUCCESS:
            let { business, ...loanApplicationRest} = action.payload;
            return {
                ...state,
				businessInfo: business,
                loanApplication: loanApplicationRest,
            };
        case types.FETCH_PENDING_LOAN_APPLICATION_FAILURE:
            return {
				...state,
                submitting: false,
                submited: false
            };
        default:
            return state
    }
};

export default app;



// WEBPACK FOOTER //
// ./src/reducers/app.js